<template>
  <mailbox-settings-layout :name="formData.name">
    <el-card class="mailbox-settings-integrations">
      <template #header>
        <h3>Integrations</h3>
      </template>
      <entity-settings-loading v-if="isLoading" />
      <template v-else>
        <p>
          Integrate <strong>{{ formData.name }}</strong> with other popular services.
          Here are the services we currently integrate with.
        </p>
        <div class="dd-divider" />
        <el-collapse v-model="activeItem" accordion @change="collapseChangeHandler">
          <slack-integration-accordion
            :entity-id="formData.id"
            :type="EEntities.MAILBOXES"
            :slack-integration="formData.slackIntegration"
          />
          <github-integration-accordion
            :entity-id="formData.id"
            :entity-name="formData.name"
            :type="EEntities.MAILBOXES"
            :github-integration="formData.gitHubIntegration"
          />
          <glip-integration-accordion
            :entity-id="formData.id"
            :type="EEntities.MAILBOXES"
            :glip-integration="formData.glipIntegration"
          />
          <harvest-integration-accordion
            :entity-id="formData.id"
            :type="EEntities.MAILBOXES"
            :harvest-integration="formData.harvestIntegration"
          />
        </el-collapse>
      </template>
    </el-card>
  </mailbox-settings-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import GithubIntegrationAccordion from '@/components/entity/integrations/github-integration-accordion.vue'
import GlipIntegrationAccordion from '@/components/entity/integrations/glip-integration-accordion.vue'
import HarvestIntegrationAccordion from '@/components/entity/integrations/harvest-integration-accordion.vue'
import SlackIntegrationAccordion from '@/components/entity/integrations/slack-integration-accordion.vue'

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IProjectsOutputIntegrations } from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import { CollapseModelValue } from 'element-plus'

export default defineComponent({
  name: 'MailboxSettingsIntegrations',

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
    GithubIntegrationAccordion,
    GlipIntegrationAccordion,
    HarvestIntegrationAccordion,
    SlackIntegrationAccordion,
  },

  data() {
    return {
      EEntities,
      isLoading: true,
      activeItem: this.$route.query.activeItem,
      formData: {
        name: '',
      } as IProjectsOutputIntegrations,
    }
  },

  head(): any {
    return {
      title: `Integrations - ${this.formData.name}`,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },

  async created() {
    this.isLoading = true
    await this.getIntegrationsInfo()
    this.isLoading = false
  },

  methods: {
    async getIntegrationsInfo() {
      try {
        this.formData = await MailboxesAPI.get_Integrations(this.id)
      } catch (error) {
        this.$error.emit(error)
      }
    },

    collapseChangeHandler(activeItem: CollapseModelValue): void {
      this.$router.replace({
        query: { activeItem: activeItem as string },
      })
    },
  },
})
</script>

<style lang="scss">
.mailbox-settings-integrations {
  overflow: visible;
  .el-collapse .el-collapse-item__wrap {
    overflow: visible;
  }
}
</style>
